module.exports = __webpack_public_path__ + "img/socologo.287bc8d7.png";